import { Grid } from '@material-ui/core'
import { Field, Formik, useFormikContext } from 'formik'
import React, { useImperativeHandle } from 'react'
import * as Yup from 'yup'
import {
  FIELD_REQUIRED,
  Form,
  FormikImageFileField,
  FormikSelect,
  FormikTextField,
} from '../../../../../ui'

const StepForm = React.forwardRef(
  ({ step, jobTypes, equipment, handler }, ref) => {
    const FormObserver = () => {
      const { values } = useFormikContext()

      useImperativeHandle(ref, () => ({
        getState() {
          return { values }
        },
      }))

      return null
    }

    const mapJobTypesToOption = ({ id, name }) => ({ value: id, label: name })

    const validationSchema = Yup.object().shape({
      step: Yup.string().required(FIELD_REQUIRED),
      jobTypeTime: Yup.number().typeError('Must be a number e.g. (20)'),
      equipmentTypeTime: Yup.number().typeError('Must be a number e.g. (20)'),
    })

    const initialValues = {
      id: step?.id || '',
      step: step?.text || '',
      stepPhoto: step?.photo || '',
      jobType: step?.jobType.id || '',
      equipmentType: step?.equipmentType.id || '',
      jobTypeTime: step?.jobType.time || '',
      equipmentTypeTime: step?.equipmentType.time || '',
    }

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={handler}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {() => (
          <>
            <Form>
              <FormObserver />
              <Field type="hidden" name="id" id="stepId" />
              <Form.InputGroup>
                <Grid container spacing={2}>
                  <Grid item md={2} xs={12}>
                    <FormikImageFileField
                      name="stepPhoto"
                      margin="normal"
                      label="Step Photo"
                    />
                  </Grid>

                  <Grid item md={10} xs={12}>
                    <FormikTextField
                      label="Type Step..."
                      margin="normal"
                      name="step"
                      variant="filled"
                      multiline
                      type="text"
                      minRows={5}
                      fullWidth
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <Form.InputSubGroup title="Labour Options">
                      <Grid container spacing={2}>
                        <Grid item md={9} xs={12}>
                          <FormikSelect
                            label="Select Job Type"
                            margin="normal"
                            name="jobType"
                            fullWidth
                            options={[...jobTypes.map(mapJobTypesToOption)]}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <FormikTextField
                            label="Time (m)"
                            margin="normal"
                            name={'jobTypeTime'}
                            variant="filled"
                          />
                        </Grid>
                      </Grid>
                    </Form.InputSubGroup>
                  </Grid>

                  <Grid item md={6}>
                    <Form.InputSubGroup title="Equipment Options">
                      <Grid container spacing={2}>
                        <Grid item md={9} xs={12}>
                          <FormikSelect
                            label="Select Equipment"
                            margin="normal"
                            name={'equipmentType'}
                            fullWidth
                            options={[...equipment.map(mapJobTypesToOption)]}
                          />
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <FormikTextField
                            label="Time (m)"
                            margin="normal"
                            name={'equipmentTypeTime'}
                            variant="filled"
                          />
                        </Grid>
                      </Grid>
                    </Form.InputSubGroup>
                  </Grid>
                </Grid>
              </Form.InputGroup>
            </Form>
          </>
        )}
      </Formik>
    )
  }
)

export default StepForm
